"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IModePreconditionSchema = void 0;
const zod_1 = require("zod");
const IModeCondition_1 = require("./IModeCondition");
exports.IModePreconditionSchema = zod_1.z.object({
    id: zod_1.z.number(),
    condition: zod_1.z.lazy(() => IModeCondition_1.IModeConditionSchema),
});
//# sourceMappingURL=IModePrecondition.js.map